export const CWC23_VENUE_ID_LIST = [
  "Ahmedabad",
  "Bengaluru",
  "Chennai",
  "Delhi",
  "Dharamshala",
  "Hyderabad",
  "Kolkata",
  "Lucknow",
  "Mumbai",
  "Pune",
];
